import { BREAKPOINTS_WIDTHS, useWindowSize } from '@belong/common';
import { Button, Text } from '@belong/ui';
import PaymentMethodModel from 'models/common/PaymentMethod';
import { QuestionsOrConcernsModalFooter } from 'post-inspection/components/question-or-concern-modal-footer/question-or-concern-modal-footer';
import { PaygPaymentMethodRow } from '../components/payg-payment-method-row';
import { PAY_AS_YOU_GO_STRINGS } from '../strings';

const STRINGS = PAY_AS_YOU_GO_STRINGS.declinedStep;

type Props = {
  canRetry: boolean;
  isPaymentUnconfirmed?: boolean;
  onRetry: () => void;
  paymentMethod: PaymentMethodModel;
};

export function PaygDeclinedStep({
  canRetry,
  isPaymentUnconfirmed,
  onRetry,
  paymentMethod,
}: Props) {
  const { width } = useWindowSize();

  const isMobile = width <= BREAKPOINTS_WIDTHS.SM;

  return (
    <div className="flex w-full flex-col items-center pt-2sm sm:pt-2xl">
      <div className="flex w-full flex-col items-center gap-xl sm:gap-2xl md:px-xl">
        <div className="flex flex-col items-center gap-xs text-center sm:max-w-[340px] md:max-w-[700px]">
          <span className="rounded-small bg-red px-xs py-2xs">
            <Text
              as="span"
              className="text-white"
              fontWeight="semibold"
              variant="p1"
            >
              {STRINGS.badge}
            </Text>
          </span>
          <Text fontWeight="semibold" variant="h2">
            {STRINGS.title}
          </Text>
          <Text variant={isMobile ? 'p1' : 'body'}>
            {canRetry ? STRINGS.subtitle : STRINGS.finalSubtitle}
          </Text>
        </div>

        <div className="flex w-full flex-col gap-2sm">
          <Text fontWeight="semibold" variant="h3">
            {STRINGS.paymentMethodTitle}
          </Text>
          <PaygPaymentMethodRow paymentMethod={paymentMethod} />
        </div>
      </div>

      <div className="mt-xl w-full pb-xl sm:mt-2xl md:pb-2xl">
        {isPaymentUnconfirmed && (
          <Text className="mb-sm text-center" variant="p1">
            {PAY_AS_YOU_GO_STRINGS.unconfirmedNote}
          </Text>
        )}
        <QuestionsOrConcernsModalFooter bareOnDesktop>
          {canRetry && (
            <Button
              className="md:w-[260px]"
              disabled={isPaymentUnconfirmed}
              onClick={onRetry}
              size={{ _: 'fluid' }}
            >
              {STRINGS.cta}
            </Button>
          )}
        </QuestionsOrConcernsModalFooter>
      </div>
    </div>
  );
}
